import React, { useState, useEffect } from 'react';

const EditResult = () => {
  const [result, setResult] = useState({
    id: 1,
    studentName: 'John Smith',
    rollNumber: '10A001',
    className: 'Grade 10',
    section: 'A',
    examName: 'Mid Term Exam',
    subject: 'Mathematics',
    marks: 85,
    maxMarks: 100,
    percentage: 85,
    grade: 'A',
    publishDate: '2023-11-15',
    description: 'Good performance in mathematics'
  });
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFormData({
      ...result
    });
  }, [result]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleMarkChange = (e) => {
    const marks = parseInt(e.target.value) || 0;
    const maxMarks = formData.maxMarks || 100;
    const percentage = maxMarks ? Math.round((marks / maxMarks) * 100) : 0;
    
    let grade = 'F';
    if (percentage >= 90) grade = 'A+';
    else if (percentage >= 80) grade = 'A';
    else if (percentage >= 70) grade = 'B+';
    else if (percentage >= 60) grade = 'B';
    else if (percentage >= 50) grade = 'C';
    else if (percentage >= 40) grade = 'D';
    
    setFormData({
      ...formData,
      marks: marks,
      percentage: percentage,
      grade: grade
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // In a real application, this would update the result in the backend
    setTimeout(() => {
      setLoading(false);
      alert('Result updated successfully!');
    }, 2000);
  };

  if (!result) {
    return (
      <div className="min-h-screen flex items-center justify-center py-8">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading result...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Edit Result</h1>
        
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-6">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label className="block text-gray-700 mb-2">Student Name</label>
                <input
                  type="text"
                  name="studentName"
                  value={formData.studentName || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Roll Number</label>
                <input
                  type="text"
                  name="rollNumber"
                  value={formData.rollNumber || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Class</label>
                <input
                  type="text"
                  name="className"
                  value={formData.className || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Section</label>
                <input
                  type="text"
                  name="section"
                  value={formData.section || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Exam Name</label>
                <input
                  type="text"
                  name="examName"
                  value={formData.examName || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Subject</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Marks *</label>
                <input
                  type="number"
                  name="marks"
                  min="0"
                  max={formData.maxMarks || 100}
                  value={formData.marks || ''}
                  onChange={handleMarkChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Max Marks *</label>
                <input
                  type="number"
                  name="maxMarks"
                  min="1"
                  value={formData.maxMarks || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Percentage</label>
                <input
                  type="text"
                  name="percentage"
                  value={`${formData.percentage || 0}%`}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div>
                <label className="block text-gray-700 mb-2">Grade</label>
                <input
                  type="text"
                  name="grade"
                  value={formData.grade || ''}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  readOnly
                />
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-gray-700 mb-2">Description</label>
                <textarea
                  name="description"
                  value={formData.description || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  rows="3"
                ></textarea>
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-gray-700 mb-2">Publish Date *</label>
                <input
                  type="date"
                  name="publishDate"
                  value={formData.publishDate || ''}
                  onChange={handleInputChange}
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />
              </div>
            </div>
            
            <div className="flex space-x-4">
              <button
                type="submit"
                disabled={loading}
                className="bg-primary text-white px-6 py-2 rounded hover:bg-blue-700 transition disabled:opacity-50 flex items-center"
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Updating...
                  </>
                ) : (
                  'Update Result'
                )}
              </button>
              <button
                type="button"
                className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600 transition"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>

        <div className="mt-8 max-w-2xl mx-auto bg-gray-50 rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Grade Scale</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-purple-100 text-purple-800 p-3 rounded text-center">
              <div className="font-bold">A+</div>
              <div className="text-sm">90-100%</div>
            </div>
            <div className="bg-green-100 text-green-800 p-3 rounded text-center">
              <div className="font-bold">A</div>
              <div className="text-sm">80-89%</div>
            </div>
            <div className="bg-blue-100 text-blue-800 p-3 rounded text-center">
              <div className="font-bold">B+</div>
              <div className="text-sm">70-79%</div>
            </div>
            <div className="bg-yellow-100 text-yellow-800 p-3 rounded text-center">
              <div className="font-bold">B</div>
              <div className="text-sm">60-69%</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditResult;